import 'intersection-observer';

(function () {
    var LOCALSTORAGE_KEY = '_url_params';

    var default_url_params = {};
    if (window.theme_settings) {
        var pardot_forms = theme_settings.pardot_forms;
        if (Array.isArray(pardot_forms)) {
            pardot_forms.forEach(function (form) {
                default_url_params[form.url] = {};
                form.default_utm_parameters.forEach(function (param) {
                    default_url_params[form.url][param.name] = param.value;
                });
            })
        }
    }

    var url_params = {};

    try {
        url_params = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY)) || {};
    } catch (e) {
        console.log(e);
    }

    var utms = ['utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content'];

    var query = window.location.search.substring(1);
    if (query.match(/\butm_/)) {
        utms.forEach(function (name) {
            delete url_params[name];
        });
    }

    var vars = query.split('&');
    var changed = false;
    for (var i = 0; i < vars.length; i++) {
        if (vars[i]) {
            var pair = vars[i].split('=');
            url_params[pair[0]] = pair[1];
            changed = true;
        }
    }

    if (changed) {
        try {
            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(url_params));
        } catch (e) {}
    }

    var iframes = document.querySelectorAll('iframe[data-src]');
    for (var i = 0; i < iframes.length; i++) {
        var observer = new IntersectionObserver(function (entries, observer) {
            for (var i = 0; i < entries.length; i++) {
                var e = entries[i];
                if (e.isIntersecting) {
                    var src = e.target.dataset.src.replace(/\?.*/, '');
                    var query = [];
                    if (Object.keys(url_params).length === 0 && default_url_params[src]) {
                        url_params = default_url_params[src];
                        // try {
                        //     localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(url_params));
                        // } catch (e) {}
                    }
                    for (var key in url_params) {
                        query.push(key + "=" + url_params[key]);
                    }
                    e.target.src = src + '?' + query.join("&");
                    observer.disconnect();
                }

            }
        }, {
            root: null,
            rootMargin: parseInt(document.documentElement.clientHeight / 3) + 'px',
            threshold: 0,
        })
        observer.observe(iframes[i]);
    }
})();
